export default __webpack_public_path__ + "static/media/_IMG5185.83be1857.jpg";